import { Button, Modal } from 'antd';
import React, { useState } from 'react';

const ConfirmationModal = ({ open, close,updateHandler }) => {
    return (
        <Modal open={open}
            centered
            onCancel={close}

            footer={[
                <Button key="submit" onClick={()=>{
                    updateHandler(true);
                    close();
                }} type="primary">
                    Yes
                </Button>,
                <Button key="back" onClick={close}>
                    No
                </Button>,
            ]} title="Confirmation">
            <p>If you switch category or type, your existing cart will be cleared. Do you wish to continue? </p>
        </Modal>
    );
};

export default ConfirmationModal;